import axios from 'axios';
import router from '../../router';
import {getAuthHeader} from  '../global_helpers/authHeader.js';
import {getUSERID} from  '../global_helpers/sessionReturn.js';


const state = {
    authContext: {
        token: null,
        userID: null,
        isSiteAdmin: false,
        tpaID: null,
        userList: null,
        userObject: null,
    },
};

const getters = {
    authContext: (state) => state.authContext,
    ifAuthenticated(state) {
        // returns a t/f value for if the user has a token in the browser
        return state.authContext.token !== null;
    },
    userList: (state) => state.authContext.userList,
    userObject: (state) => state.authContext.userObject,
};

const actions = {
    
    // run this function on route changes to see if the token is a valid token
    async checkAuth (){
        let token = sessionStorage.getItem('token');
        let authToken = "Token "+token;
        let authHeader = {headers: {
            Authorization: authToken
        }};
        if (token != null && token != '' && token != undefined){
            let url = axios.defaults.baseURL+'validate/?token='+token;
            const response = await axios.get(url, authHeader);
            return response.data.is_valid;
        }
    },

    async checkAdmin (){
        let token = sessionStorage.getItem('token');
        let authToken = "Token "+token;
        let authHeader = {headers: {
            Authorization: authToken
        }};
        if (token != null && token != '' && token != undefined){
            let url = axios.defaults.baseURL+'validate/?token='+token;
            const response = await axios.get(url, authHeader);
            return response.data.is_admin;
        }
    },

    // login action (should be a post method that sends the email and password)
    async login({commit, dispatch}, authData){
        await axios.post('/login/', {
            username: authData.username.toLowerCase(),
            password: authData.password
        }).then(res => {
            if (res.data.inactive){
                dispatch('raiseMessage', 'Unable to log in with this account.');
                return;
            }
            commit('authUser', {
                token: res.data.token,
                userID: res.data.user_id,
                tpaID: res.data.tpa_id,
                isSiteAdmin: res.data.is_site_admin
            });
            sessionStorage.setItem('token', res.data.token);
            sessionStorage.setItem('userID', res.data.user_id);
            sessionStorage.setItem('tpaID', res.data.tpa_id);
            sessionStorage.setItem('isSiteAdmin', res.data.is_site_admin);
            dispatch('getUserName')
            // dispatch('getTpa', {root: true});
            dispatch('fetchAllTPAGlobalContext', {root: true})
            router.push({path: 'dashboard'});
        }).catch(error => {
                if (error.response) {
                    if(error.response.data.non_field_errors !== undefined){
                        dispatch('raiseMessage', error.response.data.non_field_errors[0], {root: true});
                    } else if (error.response.data.responseMessage !== undefined){
                        dispatch('raiseMessage', error.response.data.responseMessage, {root: true});
                    }
                    
                }
                else if (error.request) {
                    dispatch('raiseMessage', 'Critical Error: could not contact api', {root: true});
                } else {
                    console.log(error);
                }
            });
    },
    
    async resetPass({dispatch}, authData){
        await axios.post('/resetpassword/', {
            email: authData.email,
        }).then(
            router.push({path: '/confirm'})
        ).catch(error => {
                if (error.response) {
                    if(error.response.data.email !== undefined){
                        dispatch('raiseMessage', error.response.data.email, {root: true});
                    }                    
                }
                else if (error.request) {
                    dispatch('raiseMessage', 'Critical Error: could not contact api', {root: true});
                } else {
                    console.log(error);
                }
            }
        );
    },
    
    getUserList({commit}, entity){
        let authHeader = getAuthHeader()
        axios.get('/user/ddl/?entity_type='+entity.type+'&entity_id='+entity.id, authHeader)
        .then((res) => {commit('setUserList', res.data)})
    },

    getUserName({dispatch}) {
        let authHeader = getAuthHeader();
        axios.get('/user/?user_id='+getUSERID(), authHeader)
        .then((res) => {
            sessionStorage.setItem('userName', res.data.name);
        })
        .catch(err => {
            console.log(err)
            dispatch('raiseMessage','There was an error getting username info.', {root: true})
        });
    },
    
    async clearUserObject({commit}){
        commit('clearUserObject')
    },
    
    getUserObject({commit}){
        let authHeader = getAuthHeader();
        axios.get('/user/?user_id='+getUSERID(), authHeader)
        .then((res) => {
            commit('setUserObject', res.data)
        })
    },
    
    getOtherUserObject({commit}, user_id){
        let authHeader = getAuthHeader();
        axios.get('/user/?user_id='+user_id, authHeader)
        .then((res) => {
            commit('setUserObject', res.data)
        })
    },
    
    async newPass({dispatch}, authData){
        await axios.post('/resetpassword/confirm/', {
            token: authData.token,
            password: authData.password
        }).then(res => {
            if (res.data.status === 'OK'){
                router.push({path: '/'});
            } else {
                dispatch('raiseMessage', res.data, {root: true});
            }            
        }).catch(error => {
                if (error.response) {
                    if(error.response.data.password !== undefined){
                        dispatch('raiseMessage', error.response.data.password, {root: true});
                    }
                }
                else if (error.request) {
                    dispatch('raiseMessage', 'Critical Error: could not contact api', {root: true});
                } else {
                    console.log(error);
                }
            });
    },
  
    AutoLogin ({commit, dispatch}) {
        const token = sessionStorage.getItem('token');
        if (!token) {
            console.log("AutoLogin failed!")
          return;
        }
        const userID = sessionStorage.getItem('userID');
        const tpaID = sessionStorage.getItem('tpaID');
        //const isSiteAdmin = sessionStorage.getItem('isSiteAdmin')
        commit('authUser', {
          token: token,
          userID: userID,
          tpaID: tpaID
         // isSiteAdmin: isSiteAdmin,
        });
        dispatch('getTpa', {root: true})
        dispatch('getUserName')
        dispatch('fetchAllTPAGlobalContext', {root: true})
    },

    Logout ({commit}) {
        sessionStorage.clear();
        commit('clearAuth');
        router.push({path: '/'});
    },
};

const mutations = {
    authUser (state, userData) {
        state.authContext.token = userData.token;
        state.authContext.userID = userData.userID;
        state.authContext.tpaID = userData.tpaID;
        state.authContext.isSiteAdmin = userData.isSiteAdmin
    },
    clearAuth (state){
        state.authContext.token = null;
        state.authContext.userID = null;
        state.authContext.tpaID = null;
    },
    setUserList(state, data){
        state.authContext.userList = data;
    },
    setUserObject(state, data) {
        state.authContext.userObject = data;
    },
    clearUserObject(state){
        state.authContext.userObject = null;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};